import React, { useEffect, useState } from "react";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { Calendar } from "primereact/calendar";
import { Button } from "primereact/button";
import { MultiSelect } from "primereact/multiselect";
import { InputText } from "primereact/inputtext";
import { Skeleton } from "primereact/skeleton";

import styles from "../entity-calendar.module.scss";
import useSetUpProcessModel from "./useSetUpProcessModel";
import Timezones from "../../../assets/timezone-list.json";
import { fromZonedTime } from "date-fns-tz";
import "../entity-calendar.module.scss";

const SetUpProcessModel = () => {
  const {
    serviceLine,
    setProcessType,
    processType,
    startDate,
    setStartDate,
    handleCreateProcess,
    formattedServices,
    formattedProcessTypes,
    handleSelectServiceLine,
    handleOpenProcessModal,
    toggleProcessModal,
    isProcessFetch,
    entity,
    handleCloseModal,
    role,
    loading,
    setUtcDate,
    showProcessExistModal,
    hasOnlyPayrollPlus,
  } = useSetUpProcessModel();

  const [formattedDateTimeZone, setFormattedDateTimeZone] = useState(null);

  useEffect(() => {
    const selectedTimezone = Timezones.find(
      (tz) => tz.value === entity?.timezone,
    );
    setFormattedDateTimeZone(selectedTimezone?.name);
  }, [entity]);

  const processStartDateHandler = (e) => {
    const utcDate = fromZonedTime(e.value, entity.timezone);
    setUtcDate(utcDate.toISOString());
    setStartDate(e.value);
  };

  return (
    <>
      {role === "GXM_ADMIN" && (
        <>
          <Button
            onClick={() => {
              handleOpenProcessModal();
            }}
            label="Set Up Process"
            className={`${styles["set-process-btn"]} ${styles["set-process-btn-disabled"]}`}
            loading={isProcessFetch}
            disabled={!entity?.active_services?.length || hasOnlyPayrollPlus}
          />
        </>
      )}
      <Dialog
        header={
          <div className="flex justify-content-between align-items-center">
            <span className="model-head">Set Up New Process</span>
            <i
              className="pi pi-times cross-icon"
              onClick={handleCloseModal}
            ></i>
          </div>
        }
        visible={toggleProcessModal}
        onHide={handleCloseModal}
        className="my-dialog-content"
      >
        <div className="p-fluid field-container">
          <div className="field data-field">
            <label>Entity</label>
            {!entity?.name ? (
              <Skeleton width="100%" height="2rem" />
            ) : (
              <InputText value={entity?.name} disabled></InputText>
            )}
          </div>
          <div className="field data-field">
            <label>Service Line</label>
            <Dropdown
              value={serviceLine}
              options={formattedServices}
              onChange={(e) => {
                handleSelectServiceLine(e);
              }}
              placeholder="Select service line"
              className="w-full"
            />
          </div>

          <div className="field data-field">
            <label>Process Type</label>
            <Dropdown
              value={processType}
              options={formattedProcessTypes}
              onChange={(e) => setProcessType(e.value)}
              placeholder="Select process type"
              disabled={!serviceLine}
            />
          </div>
          <div className="field data-field">
            <label>Start Date</label>
            <div
              className="calendar-container"
              style={{ position: "relative" }}
            >
              <Calendar
                value={startDate}
                onChange={processStartDateHandler}
                placeholder="Select process start date"
                minDate={new Date(Date.now())}
                showTime
                hideOnDateTimeSelect
                hourFormat="12"
              />
              <span className="pi pi-calendar calendar-icon"></span>
            </div>
          </div>
          <div className="flex align-items-center gap-1">
            <i className="pi pi-calendar" />
            <p className="m-0">
              {`Start Date is based on the entity's time zone ${formattedDateTimeZone}`}
            </p>
          </div>
        </div>
        <div className="flex justify-content-end gap-2">
          <Button
            label="Cancel"
            className={styles["cancel-btn"]}
            outlined
            onClick={handleCloseModal}
          />
          <Button
            label="Create Process"
            className={`${styles["set-process-btn"]} flex flex-row-reverse`}
            onClick={handleCreateProcess}
            loading={loading}
            disabled={serviceLine && processType && startDate ? false : true}
          />
        </div>
      </Dialog>

      <Dialog
        header={
          <div className="flex justify-content-between align-items-center">
            <span className="model-head">
              A process already exists for this entity, process type and month
            </span>
          </div>
        }
        visible={showProcessExistModal}
        onHide={handleCloseModal}
        className="process-exists-content"
      >
        <div className="process-exists-description">
          <span>
            Please verify the existing process and confirm if you still want to
            proceed with the Process creation
          </span>
        </div>
        <div className="flex justify-content-end gap-2 pt-4">
          <Button
            label="Cancel"
            className="cancel-btn"
            outlined
            onClick={handleCloseModal}
          />
          <Button
            label="Yes, Proceed"
            className="proceed-btn flex flex-row-reverse"
            onClick={() => handleCreateProcess({ force: true })}
            loading={loading}
          />
        </div>
      </Dialog>
    </>
  );
};

export default SetUpProcessModel;
